import React, { useState } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSearch } from 'react-icons/fa';
import Data from '../../components/Data';
import '../../css/financeiro-parcela-pagar.css';

export default function RelatorioDre() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const [filtro, setFiltro] = useState({ empresa: empresa });

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">DRE</h1>
                        <p className="fin-pp__subtitle">Demonstrativo de Resultado do Exercício</p>
                    </div>
                </div>

                <div className="fin-pp__card" style={{ padding: '20px 24px' }}>
                    <form method="post" target="_blank" action={process.env.REACT_APP_API_URL + "/financeiroParcela/relatorioDre"}>
                        <input type="hidden" name="token" value={token} />
                        <input type="hidden" name="empresa" value={empresa} />
                        <div className="fin-pp__filters">
                            <Data
                                inputName="pagamento1"
                                label="Data Pagamento"
                                value={filtro.pagamento1}
                                onChange={date => setFiltro({ ...filtro, pagamento1: date })}
                            />
                            <Data
                                inputName="pagamento2"
                                label="até a Data Pagamento"
                                value={filtro.pagamento2}
                                onChange={date => setFiltro({ ...filtro, pagamento2: date })}
                            />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                            <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall">
                                <FaSearch size={16} /> Gerar DRE
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </ErpTemplate>
    );
}
